import { render, staticRenderFns } from "./OldNoticeBoard.vue?vue&type=template&id=5c671298&scoped=true"
import script from "./OldNoticeBoard.vue?vue&type=script&lang=js"
export * from "./OldNoticeBoard.vue?vue&type=script&lang=js"
import style0 from "./OldNoticeBoard.vue?vue&type=style&index=0&id=5c671298&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c671298",
  null
  
)

export default component.exports